import { render } from "./WiseFooter.vue?vue&type=template&id=29dc2a41&scoped=true"
import script from "./WiseFooter.vue?vue&type=script&lang=js"
export * from "./WiseFooter.vue?vue&type=script&lang=js"

import "./WiseFooter.vue?vue&type=style&index=0&id=29dc2a41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dc2a41"]])

export default __exports__